<template>
    <BContainer class="footer fixed-bottom" style="padding: 0px 8px; background-color:#F5F7FA;">
        <BButton @Click="toUsrtop()">
            <div class="icon">
                <BImg :src="whichPage == 'マイページ' ? my_page_active_src:my_page_src" style="padding: 3px 1.5px;"></BImg>
            </div>
            {{$t("common.usr_top")}}
        </BButton>
        <BButton v-if="displayFlg1" :disabled="useFlag == 1 || !displayFlg1 || useStartDFlag == 1" @click="toElearning()" style="width:17%">
            <div class="icon">
                <BImg :src="whichPage == '研修'? search_active_src:search_src" style="padding: 3px"/>
            </div>
            {{$t("common.footer_std")}}
        </BButton>
        <BButton v-if="displayFlg2" :disabled="useFlag == 1 || !displayFlg2" @click="toElgstudy()" :class="lang == 1 ?'shrink-font':''" style="width:23%">
            <div class="icon">
                <BImg :src="whichPage == '研修管理'? event_active_src:event_src" style="padding: 1.5px 2.5px;"/>
            </div>
            <div align="center">
                <div style="word-break: keep-all;">{{$t("common.footer_elg")}}</div>
            </div>
        </BButton>

        <BButton style="width: 20%!important;height:100%!important;position: relative;" @click=toUsrInf()>
            <div class="icon">
                <BImg :src="whichPage == 'お知らせ'? bell_active_src:bell_src" style="padding: 1.5px 3.5px;"/>
                <b-badge variant="danger" dot-indicator v-if="infListLength!=0">
                    <span class="visually-hidden"></span>
                </b-badge>
            </div>
            {{$t("common.footer_inf")}}
        </BButton>

        <BButton @click="toHelp()">
            <div class="icon">
                <BImg :src="whichPage == 'ヘルプ'?help_active_src:help_src" style="padding: 1.5px 1.5px;"/>
            </div>
            {{$t("common.footer_help")}}
        </BButton>
    </BContainer>
</template>

<script>
import { useRouter } from 'vue-router'
import { ref,inject,onBeforeMount } from 'vue'
import { cryptoEffect } from '@/utils/cryptoUtil'
import { post } from '@/utils/request'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { removeToken } from '@/utils/CookieUtils'
export default {
    name: "b_footer",
    props:{
        whichPage: String,
    },
    setup(props){
        const store = useStore()
        const my_page_src = require('@/assets/icon/my_page.svg')
        const my_page_active_src = require('@/assets/icon/my_page_active.svg')
        const search_src = require('@/assets/icon/search.svg')
        const search_active_src = require('@/assets/icon/search_active.svg')
        const event_src = require('@/assets/icon/event.svg')
        const event_active_src = require('@/assets/icon/event_active.svg')
        const bell_src = require('@/assets/icon/bell.svg')
        const bell_active_src = require('@/assets/icon/bell_active.svg')
        const help_src = require('@/assets/icon/help.svg')
        const help_active_src = require('@/assets/icon/help_active.svg')
        const whichPage = ref(props.whichPage || "マイページ")
        const router = useRouter()
        const infListLength = ref(0)
        const service = inject('service')
        const { decrypt } = cryptoEffect()
        const useFlag = Number(decrypt(localStorage.getItem('useFlag')).charAt(9))
        const useStartDFlag = Number(decrypt(localStorage.getItem('useFlag')).charAt(10))
        const displayFlg1=  ref(store.getters.getDisplayFlg1)
        const displayFlg2=  ref(store.getters.getDisplayFlg2)
        const displayFlg5=  ref(store.getters.getDisplayFlg5)
        const { locale } = useI18n({ useScope: 'global' })
        const dispatchAgencyFlag = ref(false)
        const lang = locale.value == 'ja' ? ref('0'):ref('1')
        onBeforeMount(async ()=>{
            if(sessionStorage.getItem('infListLength') && sessionStorage.getItem('infListLength') != 0){
                infListLength.value = sessionStorage.getItem('infListLength')
            }else{
                service.notification.getListAndUnReadCount().then(res => {
                    infListLength.value = res.unReadCountByMng + res.unReadCountBySys
                    sessionStorage.setItem('infListLength', infListLength.value)
                })
            }
            await post('/api/user/getCipherInfo').then(res => {
              if (res.data == null) {
                removeToken()
                router.push({path: '/login'})
                sessionStorage.clear()
                if (localStorage.getItem('session_timeout')) {
                  var temp = JSON.parse(decrypt(localStorage.getItem('session_timeout')))
                  temp.isSaveLoginInfo = 0
                  temp.password = ''
                  localStorage.setItem('session_timeout', encrypt(JSON.stringify(temp)))
                }
              } else {
                    dispatchAgencyFlag.value = res.data.isDispatchAgencyFlag
                    if(res.data.loginInfo.displayFlg1 != 1 ){
                        store.commit('changeDisplayFlg1',true)
                        displayFlg1.value = true
                    }else{
                        store.commit('changeDisplayFlg1',false)
                        displayFlg1.value = false
                    }
                    if(res.data.loginInfo.displayFlg2 != 1){
                        store.commit('changeDisplayFlg2',true)
                        displayFlg2.value = true
                    }else{
                        store.commit('changeDisplayFlg2',false)
                        displayFlg2.value = false
                    }
                    if(res.data.loginInfo.displayFlg5 != 1){
                        store.commit('changeDisplayFlg5',true)
                        displayFlg5.value = true
                    }else{
                        store.commit('changeDisplayFlg5',false)
                        displayFlg5.value = false
                    }
                }
            })
        })

        function toUsrtop(){
            router.push({path: '/usr_top'})
        }

        function toElearning(){
            if(useFlag == 1 || !store.getters.getDisplayFlg1 || useStartDFlag == 1){
                return
            }else{
                router.push({path: '/elearning'})
            }
        }

        function toElgstudy(){
            if(useFlag == 1 || !store.getters.getDisplayFlg2){
                return
            }else{
                router.push({path: '/elgstudy'})
            }
        }

        function toUsrInf(){
            router.push({path: '/usr_inf'})
        }

        function toHelp(){
            router.push({path: '/help'})
        }
        return{
            lang,
            useStartDFlag,
            my_page_src,
            my_page_active_src,
            search_src,
            search_active_src,
            event_src,
            event_active_src,
            bell_src,
            bell_active_src,
            help_src,
            help_active_src,
            useFlag,
            whichPage,
            infListLength,
            displayFlg1,
            displayFlg2,
            displayFlg5,
            toUsrtop,
            toElearning,
            toElgstudy,
            toUsrInf,
            toHelp
        }
    },
}
</script>

<style lang="scss" scoped>
    .btn:disabled{
        background-color: #F5F7FA;
        color: #CCCCCC;
        backdrop-filter: blur(4px);
    }
    .btn:focus{
        background-color: #F5F7FA;
        color: #676F79;
    }
    .shrink-font{
        font-weight: 300!important;
        font-size: 8px!important;
        line-height: 7px!important;
    }
    .footer{
    width: 100%;
    height: 48px;
    display: flex;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: #676F79;
    justify-content: space-around;
    border-top: 1px solid #E8E8E8;
    .btn{
        font-weight: 300;
        font-size: 10px;
        line-height: 12px;
        color: #676F79;
        width: 20%;
        padding: 0%;
        background: #F5F7FA;
        border:none;
        -webkit-box-shadow: none!important;
        box-shadow: none!important;
        outline: 0;
        .icon{
            margin-bottom: 2px;
        }
        .top-0 {
            top: calc(25%)!important;
        }
        .bg-danger{
            background-color: #EE4967!important;
        }
        .p-2{
            padding: 4px!important;
        }
        .start-100{
            left: calc(50% + 8px) !important
        }
    }
    .btn:active{
        background-color: #F5F7FA;
        color: #676F79;
    }
    .btn:hover{
        background-color: #F5F7FA;
        color: #676F79;
    }
    .btn:focus{
        background-color: #F5F7FA;
        color: #676F79;
    }
    .button-wrapper{
        width: 20%;
        background-color: #F3F7FD;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon{
            margin-bottom: 2px;
        }
        .btn{
            width: 24px!important;
        }
    }
}
</style>

